var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-cascader', _vm._g(_vm._b({ ref: "cascaderRef", attrs: { "placeholder": _vm.config.isMultiple ? '请输入标签组或标签名' : '请输入关键词（单选）', "options": _vm.tagOptions, "props": _vm.defaultProps, "show-all-levels": false, "clearable": "", "filterable": "" }, on: { "change": _vm.handleChange }, model: { value: _vm.formValue[_vm.innerConfig.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.innerConfig.prop, $$v);
      }, expression: "formValue[innerConfig.prop]" } }, 'el-cascader', _vm.innerConfig.params, false), _vm.$listeners));
};
var staticRenderFns = [];

export { render, staticRenderFns };